import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { Property } from '../../../../../models/Property';
import LoadingImages from './ImageLoading/LoadingImages';

interface ImageGalleryProps {
  property: Property;
  setShowImageModal: Dispatch<SetStateAction<boolean>>;
}

export default function ImageGallery({ property, setShowImageModal }: ImageGalleryProps) {

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!property?.images || property.images.length === 0) {
      setIsLoading(false);
      return;
    }
  
    setIsLoading(true);
    
    const img = new Image();
    img.src = property.primaryImage;
  
    const handleLoad = () => setIsLoading(false);
    const handleError = () => setIsLoading(false);
  
    img.onload = handleLoad;
    img.onerror = handleError;
  
    return () => {
      img.onload = null;
      img.onerror = null;
    };
  }, [property]);
  

  return (
    <div className="summary-page--image-container">
      {isLoading ? (
        <LoadingImages loadingContainerClass="property-img-container"/>
      ) : property.images.length > 0 ? (
        <div className="property-img-container" onClick={() => setShowImageModal(true)}>
          <div id="image-text">
            <p>Click for More Images</p>
          </div>
          <img src={property.primaryImage} className="summary-page--property-img" alt="Property" />
          <span className="esri-icon-zoom-out-fixed more-images"></span>
          {property.images.length > 1 && (
            <div className="multiple-images-text">There are multiple images</div>
          )}
        </div>
      ) : (
        <div className="no-images">
          <span>No Images Available</span>
        </div>
      )}
    </div>
  );
}
